import React from 'react';
import { useNavigate } from 'react-router-dom';

function WaitlistConfirm() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1b4332 0%, #2d6a4f 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>✓</div>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem' }}>
        You're on the list.
      </h1>
      <p style={{
        fontSize: '1.1rem',
        color: 'rgba(255,255,255,0.85)',
        maxWidth: '480px',
        lineHeight: 1.7,
        marginBottom: '2rem'
      }}>
        We'll notify you when somebody.gives opens to Springfield
        donors. You'll be among the first to take responsibility
        for a local need.
      </p>
      <p style={{
        fontSize: '0.9rem',
        color: 'rgba(255,255,255,0.6)',
        maxWidth: '400px',
        lineHeight: 1.6,
        marginBottom: '2.5rem'
      }}>
        In the meantime, if you know a Springfield nonprofit
        that could benefit from predictable supply donations,
        send them to somebody.gives/org.
      </p>
      <a href="/org" style={{
        background: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        color: 'white',
        padding: '0.75rem 1.5rem',
        borderRadius: '8px',
        textDecoration: 'none',
        fontSize: '0.9rem',
        fontWeight: 600
      }}>
        Learn about somebody.gives for nonprofits →
      </a>
    </div>
  );
}

export default WaitlistConfirm;